import TooltipHover from "@/components/ui/TooltipHover";
import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
  cellValue: string;
}

export const CellWithTooltip = ({ cellValue, className, ...props }: Props) => {
  return (
    <div {...props} className={cn(className, "truncate text-ellipsis")}>
      <TooltipHover placement="bottom" text={cellValue}>
        <p className="line-clamp-1 text-left">{cellValue}</p>
      </TooltipHover>
    </div>
  );
};
